import React from "react";
const History = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5951_139918)">
      <path
        d="M0.833008 3.33203V8.33203H5.83301"
        stroke="#374151"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.92467 12.5C3.465 14.0337 4.48912 15.3502 5.84272 16.2512C7.19632 17.1522 8.80608 17.5889 10.4294 17.4954C12.0528 17.402 13.6018 16.7835 14.8431 15.7332C16.0844 14.6828 16.9507 13.2575 17.3115 11.672C17.6723 10.0865 17.5081 8.42667 16.8435 6.94262C16.179 5.45857 15.0501 4.2307 13.627 3.44401C12.204 2.65732 10.5638 2.35442 8.95357 2.58097C7.34338 2.80751 5.85043 3.55122 4.69967 4.70004L0.833008 8.33337"
        stroke="#374151"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.25V10L13.3333 11.6667"
        stroke="#374151"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5951_139918">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default History;
